<template>
  <b-modal
    hide-footer
    no-close-on-backdrop
    v-model="visible"
    header-bg-variant="warning"
    dismissible
  >
    <template #modal-header="{ close }">
      <h3>ATENÇÃO</h3>

      <b-button @click="close" variant="warning">
        <i class="fas fa-times button" />
      </b-button>
    </template>
    <div class="row justify-content-center">
      <i
        style="font-size: 60px; color: #dc3545;"
        class="fas fa-exclamation-triangle"
      />
    </div>
    <br />
    <div class="row justify-content-center" style="font-size: 20px;">
      <b> {{ text }} </b>

      <br />
      <div align="center">
        Recomendamos a renovação do certificado digital
        <b>Obrigatório para emissão de Notas Fiscais</b>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      visible: false
    };
  },
  computed: {
    company() {
      return this.$store.state.company;
    },
    certificate() {
      return this.$store.state.company.certificate;
    },

    certificateActive() {
      if (this.company.active_certificate_id) {
        return this.certificate.filter(row => {
          return (
            row.id == this.company.active_certificate_id && row.status == 1
          );
        })[0];
      } else {
        null;
      }
    },

    certificateExpiresIn() {
      if (this.company.active_certificate_id) {
        return moment(this.certificateActive.valid_to_date).diff(
          moment().startOf("day"),
          "days"
        );
      }
    },

    certificateExpired() {
      if (this.company.active_certificate_id) {
        return (
          moment(this.certificateActive.valid_to_date).diff(moment(), "days") <
          0
        );
      }
    },

    isVisible() {
      return this.certificateExpired || this.certificateExpiresIn < 30;
    },

    text() {
      if (this.certificateExpired) {
        return "Seu certificado digital expirou.";
      }
      return `Seu certificado digital expira em ${this.certificateExpiresIn} dias.`;
    }
  },

  watch: {
    isVisible() {
      this.visible = this.isVisible;
    }
  },
  mounted() {
    this.visible = this.isVisible;
  }
};
</script>

<style>
</style>